export default "__VITE_ASSET__6991153e__"